var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "clipboard-saved-toast",
      attrs: { type: "button", "data-type": "success", "aria-live": "polite" },
      on: { click: _vm.dismiss },
    },
    [
      _c(
        "div",
        {
          staticClass: "clipboard-saved-toast__icon",
          attrs: { "data-icon": "" },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                width: "24",
                height: "24",
                "aria-hidden": "true",
              },
            },
            [
              _c("circle", {
                attrs: { cx: "10", cy: "10", r: "10", fill: "#111827" },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#fff",
                  "fill-rule": "evenodd",
                  d: "M13.477 7.823a.75.75 0 0 1 .042 1.052l-3.928 4.284a.75.75 0 0 1-1.086.004l-2.09-2.308a.75.75 0 1 1 1.108-1.012l1.54 1.7 3.41-3.72a.75.75 0 0 1 1.052-.042Z",
                  "clip-rule": "evenodd",
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "clipboard-saved-toast__content",
          attrs: { "data-content": "" },
        },
        [
          _c(
            "div",
            {
              staticClass: "clipboard-saved-toast__title",
              attrs: { "data-title": "" },
            },
            [_vm._v("\n      Saved to Clipboard\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "clipboard-saved-toast__description",
              attrs: { "data-description": "" },
            },
            [_vm._v("\n      " + _vm._s(_vm.description) + "\n    ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }